import { useContext } from 'react';

import {
  AuthContext,
  AuthContextValue,
} from '@/providers/AuthProvider/AuthProvider';

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};
